module.exports = __webpack_public_path__ + "static/media/dungeon_floor_se2.a61bc509.png";